import { actions, bugReportByCode, BugReportWithUser } from 'entities';
import { useLang } from 'hooks/lang';

import {
  Button,
  Dot,
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTitle,
  LabeledTextarea,
  Modal,
  Row,
} from 'components/Blocks';
import { ArrowRightIcon, SendIcon, WorkflowIcon } from 'components/Icons';
import { EntityStatusTag } from 'components/Entities';

import { useFormControlV2 } from 'hooks';

interface BugReportStatusChangeProps {
  report: BugReportWithUser;
  updateReport: (data: Partial<BugReportWithUser>) => void;
}

export function BugReportStatusChange({ report, updateReport }: BugReportStatusChangeProps) {
  const { t } = useLang();

  const { status } = report;

  const [form, { dispatch, handleChange, resetDefault }] = useFormControlV2({
    status: '',
    comment: '',
  });

  const changeStatus = actions.feedback.changeBugReportStatus.use({
    params: { ...form, reportId: report.id },

    onSuccess: (_, params) => {
      updateReport(params);
      resetDefault();
    },
  });

  const { statusTargets } = bugReportByCode[status];

  if (!statusTargets.length) return null;

  return (
    <>
      <Modal
        isOpen={!!form.status}
        close={resetDefault}
        title={t('add-comment?')}
        width="min(80%, 450px)"
        gap="6"
        allowEscape
      >
        <Row justifyContent="center">
          <EntityStatusTag target="bugReport" status={report.status} />

          <ArrowRightIcon />

          <EntityStatusTag target="bugReport" status={form.status} />
        </Row>

        <LabeledTextarea
          label={t('complementary-comment')}
          value={form.comment}
          onChange={handleChange}
          name="comment"
        />

        <Button variant="outlined" {...changeStatus.buttonProps}>
          <SendIcon />
          {t('send')}
        </Button>
      </Modal>

      <DropdownMenu triggerIcon={<WorkflowIcon />} align="start">
        <DropdownMenuTitle>{t('update-status')}</DropdownMenuTitle>

        {statusTargets.map((target) => (
          <DropdownMenuItem key={target} onClick={() => dispatch({ status: target })}>
            <Dot color={bugReportByCode[target].color} />
            {bugReportByCode[target].getLabel(t)}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </>
  );
}
